import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AttachmentsService } from 'src/app/services/attachments.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogInfoComponent } from 'src/app/dialogs/dialog-info/dialog-info.component';

@Component({
    selector: 'app-download-attachments',
    templateUrl: './download-attachments.component.html',
    styleUrls: ['./download-attachments.component.scss'],
    standalone: false
})

export class DownloadAttachmentsComponent implements OnInit {
	@Input () idReq: number;
	@Input () title: string;
	@Input () bodyMessage: string;
	@Input () service: string;
	@Input () message: number = -1;
	loading: boolean = false;

	constructor(
			public activeModal: NgbActiveModal,
			public simpleModal: NgbModal,
			private attachmentServ: AttachmentsService
		) {
			this.title = 'Descargar Todos los Documentos';
			this.bodyMessage = 'Será generado un archivo para descargar todos los adjuntos del requerimiento';
			this.service = 'trackvision';
		}

	ngOnInit() {
	}

	confirmDownloadAll(event) {
		if (event) {
			this.loading = true;
			this.attachmentServ.downloadAttachments(this.idReq, this.service).subscribe((resp) => {
				if (resp['error']) {
					this.loading = false;
					this.message = 0;
					const content = `Hubo un error en la petición, intente de nuevo mas tarde (${resp['error']['message']})` ;
					this.loadInfoModal('Error en la petición', content)
				} else {

					this.message = 1;
					this.loading = false;
					setTimeout(() => this.activeModal.dismiss(), 2000);
					const result = resp['result']
					if(result['result'] == true) {
						if(result['async'] == true) {
							const content = result['message'];
							this.loadInfoModal('Descarga en proceso', content)
						} else {
							window.open(result['url'], '_blank');
						}
					} else {
						const content = 'Hubo un error en la petición, intente de nuevo mas tarde';
						this.loadInfoModal('Error en la petición', content)
					}
				}
			});
		}
	}

	loadInfoModal(title, message) {
		const modalRef = this.simpleModal.open(DialogInfoComponent, {
			size: 'md', backdrop: 'static',
			keyboard: false
		});
		modalRef.componentInstance.mainTitle = title;
		modalRef.componentInstance.mainMessage = message;
	}
}
